import React, {Suspense, lazy} from 'react';
import {Route, Redirect, Switch, useLocation} from 'react-router-dom';
import {AnimatePresence} from 'framer-motion';

import config from './../config';
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import Loader from '../ui-component/extended/Loader/Loader';
import Services from '../services/index';
import '../assets/css/rsuite-rtl.css'
const NotFoundPage = lazy(() => import('../views/default/NotFound'));

const Routes = () => {
    const listRouters=[
        '/home/dashboard/default',

        '/home/tables/tbl-basic',
        '/home/tables/tbl-dense',

        '/home/utils/util-typography',
        '/home/utils/util-color',
        '/home/utils/util-shadow',
        '/home/icons/tabler-icons',
        '/home/icons/material-icons',


        '/home/donvi',
        '/home/nhanvien',
        '/home/dvhc',
        '/home/hopdong',
        '/home/khachhang',
        '/home/dichvu',
        '/home/dexuat',
        "/home/statistic/customer",
        "/home/statistic/unit",
        "/home/statistic/marketshare",
        "/home/history/all",
        "/login",
        "/logout",
        // "/home/trungtam"
    ]
    const location = useLocation();
    return (
        <AnimatePresence>
            <Suspense fallback={<Loader />}>
           
                <Switch>
                    <Redirect exact from="/" to={config.defaultPath} />
                    <>
                        <Route exact path={'/login'}><LoginRoutes /></Route>
                        <Route exact path="/logout" render={() => {Services.getDangXuatService().dangXuat(); return <Redirect to="/login" />;}}/>
                        <Route exact
                            path={[
                                '/home/dashboard/default',
                                '/home/donvi',
                                '/home/nhanvien',
                                '/home/khachhang',
                                '/home/dvhc',
                                '/home/hopdong',
                                '/home/dichvu',
                                '/home/dexuat',
                                '/home/khachang',
                                "/home/statistic/customer",
                                "/home/statistic/unit",
                                "/home/statistic/marketshare",
                                "/home/history/all",
                                // "/home/trungtam"
                                // "/home/*"
                            ]}
                        > <MainRoutes /></Route>
                        <Route path='/404'exact={true} ><NotFoundPage/></Route>
                        <Route path="*" render={(e) => { if(!listRouters.includes(e.location.pathname)){ return <Redirect to="/404" />;}}}/>
                    </>
                </Switch>
            </Suspense>
            
        </AnimatePresence>
    );
};

export default Routes;
